<script setup lang="ts">
import { onClickOutside } from '@vueuse/core'
import { ref } from 'vue'

const props = defineProps({
  modalStore: {
    type: Object,
    required: true,
  },
  widthClass: {
    type: String,
    default: 'w-1/2',
  },
})

const target = ref(null)
onClickOutside(target, (e) => props.modalStore.close())
</script>

<template>
  <Teleport to="body">
    <div class="fixed inset-0 z-[999999] bg-black/30" :class="{ hidden: !modalStore.state.active }">
      <div class="absolute left-1/2 top-20 -translate-x-1/2 rounded-lg bg-white p-10" :class="widthClass" ref="target">
        <slot></slot>
      </div>
    </div>
  </Teleport>
</template>
